// voice/voiceLogPrivacy.js
//
// Privacy guard for voice telemetry. Production logs must never contain
// spoken or typed content — transcripts, prompts, replies, and summaries
// are always reduced to character counts, including in development. Event
// names, phases, error classifications, and identifiers pass through
// untouched.
//
// Keep this module byte-identical between the client and superadmin
// portals.

const CONTENT_KEYS = Object.freeze([
  "transcript",
  "prompt",
  "text",
  "reply",
  "message",
  "summary",
  "utterance",
]);

export function isVoiceContentLoggingEnabled() {
  return false;
}

export function sanitizeVoiceLogDetail(detail) {
  if (!detail || typeof detail !== "object" || Array.isArray(detail)) {
    return detail;
  }
  const safe = {};
  Object.entries(detail).forEach(([key, value]) => {
    if (CONTENT_KEYS.includes(key)) {
      safe[`${key}Chars`] = typeof value === "string" ? value.length : null;
    } else {
      safe[key] = value;
    }
  });
  return safe;
}
